import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';
import { namespace } from '../../../config.json';

class DeleteKeyButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            modalErrorAlert: '',
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submit = this.submit.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({ showModal: false });
    }

    // Fired when modal is submitted
    submit() {
        // Launching delete key action
        this.props.deleteKey(this.props.username, this.props.access).then(
        () => {
            this.closeModal();
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback();
            }
        }
        ).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            } else {
                this.setState({
                    modalErrorAlert: `Unable to process the request as the
                                     server returned an Internal Error.`,
                });
            }
        }
        );
    }

    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        let uiKeyAlert = null;

        if (this.props.isUiKey) {
            uiKeyAlert = <Alert bsStyle="danger">
                <strong>
                    <i className="fa fa-exclamation-triangle"
                      style={{
                          color: 'red',
                      }}></i>
                    &nbsp;
                    This key was created by S3 Console for use in the current
                    session and cannot be removed.
                </strong>
            </Alert>;
        }

        return (
            <div>
                <i className="fa fa-times" onClick={ this.openModal } style={{
                    cursor: 'pointer',
                }}></i>

                <Modal show={this.state.showModal} onHide={ this.closeModal }>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-edit"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            {'Delete '}
                            {this.props.userType}
                            {"'s key"}
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        {
                            this.props.isUiKey ? null :
                            <p>Are you sure you want to delete key
                                <span>&nbsp;</span>
                                <strong>{this.props.access}</strong>
                                <span>&nbsp;</span>
                                from {this.props.userType}
                                <span>&nbsp;</span>
                                <strong>{this.props.username}</strong>
                                ?
                            </p>
                        }
                        {uiKeyAlert}
                        {
                            this.props.isUiKey ? null :
                            <Alert bsStyle="warning">
                                <strong>
                                    <i className="fa fa-exclamation-triangle"
                                      style={{
                                          color: 'orange',
                                      }}></i>
                                    &nbsp;This cannot be undone</strong>
                            </Alert>
                        }
                        {errorAlert}
                    </Modal.Body>
                    {
                        this.props.isUiKey ? null :
                        <Modal.Footer
                            style={this.props.isUiKey ?
                                null : brandingStyles.backgrounds.panel
                            }
                        >
                            <button
                              className={'btn btn-primary'}
                              style={brandingStyles.buttons.primary}
                              onClick={ this.submit }>
                              Proceed
                            </button>
                            <button
                              className="btn btn-primary"
                              style={brandingStyles.buttons.primary}
                              onClick={ this.closeModal }>
                              Cancel
                            </button>
                        </Modal.Footer>
                    }
                </Modal>
            </div>

        );
    }

}

// Username is mandatory for delete operation to work
DeleteKeyButtonComponent.propTypes = {
    username: PropTypes.string.isRequired,
    userType: PropTypes.string.isRequired,
    access: PropTypes.string.isRequired,
    isUiKey: PropTypes.bool.isRequired,
    deleteKey: PropTypes.func.isRequired,
    callback: PropTypes.func,
};

export default DeleteKeyButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/DeleteKeyButton.js
 **/